<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer005">
<p class="full"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">
<img alt="" src="images/Titlepage.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062847355_Titlepage.vue?0dbf3161